import script from "./SmMenuTabBar.vue?vue&type=script&lang=ts&setup=true"
export * from "./SmMenuTabBar.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__